import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { t } from 'translation'

class AuthErrorBox extends Component {
  componentDidMount() {
    // If api error and either form error exists, means user attempted to
    // change form since the api error occured, so reset api error
    const existingError = this.props.formFields.some(
      (field) => this.props.formErrors[field]
    )

    if (existingError && this.props.apiResponseError) this.props.resetApiResponseError()
  }

  render() {
    const existingError = this.props.formFields.find(
      (field) => this.props.formTouched[field] && this.props.formErrors[field]
    )

    const errorMessageCode = existingError
      ? this.props.formErrors[existingError]
      : this.props.apiResponseError

    return errorMessageCode ? (
      <div className={`form_error ${this.props.className || ''}`}>
        {process.env.NODE_ENV === 'production'
          ? t(`${this.props.namespace}.${errorMessageCode}`, t('auth.ERROR'))
          : t(`${this.props.namespace}.${errorMessageCode}`)}
      </div>
    ) : null
  }
}

export default AuthErrorBox

AuthErrorBox.propTypes = {
  apiResponseError: PropTypes.string.isRequired,
  formFields: PropTypes.array.isRequired,
  formErrors: PropTypes.object.isRequired,
  namespace: PropTypes.string,
  resetApiResponseError: PropTypes.func.isRequired,
}

AuthErrorBox.defaultProps = {
  namespace: 'auth',
}
